import React, { useState, useEffect } from "react";

import { FormControlLabel, Switch } from "@mui/material";
import Feedback from "./Feedback";
import Information from "./Information";
import UserMenu from "./UserMenu";
import { useNavigate } from "react-router-dom";

function Header({
  activeTab,
  handleTabChange,
  toggleMenu,
  isMenuOpen,
  handleLogout,
  geocoderContainerRef,
  showSearch = false,
  showFavorites = false,
  showLinks = false,
  handleUpgrade,
  isSubscribed = false,
  // County selector props
  selectedCounty,
  countiesList = [],
  onCountyChange,
  showCountySelector = false,
}) {
  const navigate = useNavigate();
  const [showFeedbackModal, setShowFeedbackModal] = useState(false);
  const [showNotificationModal, setShowNotificationModal] = useState(false);
  const storedName = localStorage.getItem('name') || 'User';
  const storedEmail = localStorage.getItem('email') || 'unknown';
  // Upgrade button handler
  const handleUpgrade1 = () => {
    // navigate('/stripe-integration');
    navigate("/pricing");
    // navigate('/payment');
    // navigate('/stripe');

    // navigate('/premium');
  };
  useEffect(() => {
    if (activeTab === "all" && geocoderContainerRef.current) {
      if (
        geocoderContainerRef.current.childNodes.length === 0 &&
        window.geocoderInstance
      ) {
        geocoderContainerRef.current.appendChild(
          window.geocoderInstance.onAdd(window.initializedMap)
        );
      }
    }
  }, [activeTab, geocoderContainerRef]);

  return (
    <div className="headerTop">
      <div className="dflex subHeaderTop" style={
        showCountySelector ? {
          // Grid layout for NC component with county selector
          display: 'grid',
          gridTemplateColumns: '1fr auto 1fr',
          alignItems: 'center',
          gap: '20px'
        } : {
          // Original flex layout for dashboard and other pages
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }
      }>
        {/* FlowLogic Icon - LEFT */}
        <a href="/dashboard" style={{
          display: 'block',
          width: 'fit-content',
          zIndex: 10
        }}>
          {/* <a href="/points"> */}
          <img
            className="logo"
            src="/assets/Flowlogic-Logo.svg"
            alt="FlowLogic Icon"
          />
        </a>

        {/* County Selector - CENTER (only shown in NC component) */}
        {showCountySelector && (
          <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
          }}>
            <style>
              {`
                .county-dropdown-header {
                  appearance: none;
                  -webkit-appearance: none;
                  -moz-appearance: none;
                }
                .county-dropdown-header option:checked {
                  background-color: #1c8f7d;
                  color: #fff;
                }
              `}
            </style>
            <select
              className="county-dropdown-header"
              value={selectedCounty}
              onChange={onCountyChange}
              style={{
                width: "320px",
                height: "40px",
                padding: "0 40px 0 15px",
                borderRadius: "28px",
                border: "1px solid rgba(0, 0, 0, 0.1)",
                fontSize: "14px",
                background: "#fff url('data:image/svg+xml;charset=UTF-8,%3Csvg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" viewBox=\"0 0 16 16\"%3E%3Cpath fill=\"%23666\" d=\"M8 11L3 6h10z\"/%3E%3C/svg%3E') no-repeat right 15px center",
                backgroundSize: "16px",
                color: "#333",
                cursor: "pointer",
                fontWeight: 400,
                boxShadow: "0 0 0 2px rgba(0,0,0,.1)",
                outline: "none",
                transition: "box-shadow 0.2s",
              }}
            >
              <option value="all">
                All North Carolina
              </option>
              {countiesList.map(c => (
                <option
                  key={c}
                  value={c.toLowerCase()}
                >
                  {c}
                </option>
              ))}
            </select>
          </div>
        )}

        {/* Right Side Elements - RIGHT */}
        <div className="headerRightOuter" style={{
          display: 'flex',
          justifyContent: 'flex-end',
          alignItems: 'center'
        }}>
          <div class="headerMiddleOuter">
            {showFavorites && (
              <a
                onClick={() =>
                  handleTabChange(activeTab === "favorites" ? "all" : "favorites")
                }
                className={`tab-button favorites ${activeTab === "favorites" ? "favorites-active" : ""
                  }`}
              >
                <img
                  src={
                    activeTab === "favorites"
                      ? "/assets/favorite.svg" // active icon
                      : "/assets/heart.svg" // inactive icon
                  }
                  alt="My favorites"
                />{" "}
                Favorites
              </a>
            )}

            <div className="iconGroup">
              {!isSubscribed && (
                <button className="upgrade-btn" onClick={handleUpgrade1}>
                  Upgrade
                </button>
              )}
            </div>

            {showLinks && (
              <div className="iconGroup">
                <Information /> {/* Information details */}
                <Feedback /> {/* Feedback form */}
              </div>
            )}

            <div className="profilePic">
              <div
                style={{
                  width: 40,
                  height: 40,
                  borderRadius: '50%',
                  backgroundColor: '#1C8F7D',
                  color: 'white',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  fontWeight: 'bold',
                  userSelect: 'none',
                  cursor: 'pointer'
                }}
                aria-label="User Initial"
                title={storedEmail}
              >
                {storedName.charAt(0).toUpperCase()}
              </div>

            </div>

          </div>
          <UserMenu
            isMenuOpen={isMenuOpen}
            toggleMenu={toggleMenu}
            handleLogout={handleLogout}
          />
        </div>
      </div>


      {/* Search Box - Only if showSearch is true and showCountySelector is false */}
      {showSearch && !showCountySelector && activeTab !== "favorites" && (
        <div className="search">
          <div ref={geocoderContainerRef} className="geoCodeSerach"></div>
        </div>
      )}
    </div>
  );
}

export default Header;
